import React from "react";
import IconTitle from "./IconTitle";
import {
  AdobeDwIcon,
  AmazonIcon,
  AndroidIcon,
  AngularIcon,
  ApiIcon,
  AsanaIcon,
  AskFmIcon,
  AtlassianIcon,
  AtomIcon,
  AwsIcon,
  BadooIcon,
  BambooIcon,
  BaseCampIcon,
  BitBucketIcon,
  CarrierLookUpIcon,
  ChashIcon,
  ChatGptIcon,
  CodepenIcon,
  ConfluenceIcon,
  ConstantContactIcon,
  ContactShareIcon,
  CookieIcon,
  CplusPlusIcon,
  CryIcon,
  Css3Icon,
  DeliveryTruckIcon,
  DirectHitIcon,
  DiscordIcon,
  DissatisfiedIcon,
  DockerIcon,
  DropBoxIcon,
  DrupalIcon,
  EdgeIcon,
  EmailParserIcon,
  EverNoteIcon,
  EvilIcon,
  ExcelIcon,
  FacebookIcon,
  FaceTimeIcon,
  FigmaIcon,
  FileFolderIcon,
  FinderIcon,
  FlickrIcon,
  FlowMapIcon,
  FollowUpBossIcon,
  FourSquareIcon,
  FriendlyIcon,
  GcalendarIcon,
  GdocIcon,
  GDriveIcon,
  GiftWrappedIcon,
  GitIcon,
  GmailIcon,
  GmapIcon,
  GmeetIcon,
  GoIcon,
  GoogleChromeIcon,
  GoogleIcon,
  GoogleSheetIcon,
  HangoutsIcon,
  HappyIcon,
  HospitableIcon,
  Html5Icon,
  HubSpot1Icon,
  IeIcon,
  InstagramIcon,
  IntercomIcon,
  IosIcon,
  JavaIcon,
  JavascriptIcon,
  JbAppCodeIcon,
  JbCilonIcon,
  JbDataGripIcon,
  JbDotCoverIcon,
  JbDotMemoryIcon,
  JbDotPeekIcon,
  JbDotTraceIcon,
  JbGolandIcon,
  JbHubIcon,
  JbIntelliJIcon,
  JbKotlinIcon,
  JbPhpStormIcon,
  JbPyCharmEduIcon,
  JbPyCharmIcon,
  JbReshaperCppIcon,
  JbReshaperIcon,
  JbRiderIcon,
  JbRubyMineIcon,
  JbTeamCityIcon,
  JbToolBoxAppIcon,
  JbUpSourceIcon,
  JbWebStormIcon,
  JbYouTrackIcon,
  JiraCoreIcon,
  JiraIcon,
  JiraOpsIcon,
  JiraServiceDeskIcon,
  JoomlaIcon,
  JqueryIcon,
  KakaoTalkIcon,
  KayakoIcon,
  LineIcon,
  LinkedInIcon,
  LoveIcon,
  MailChimpIcon,
  MasterCardIcon,
  MessagesIcon,
  MessengerIcon,
  MicrosoftIcon,
  MozillaIcon,
  MsOneDriveIcon,
  MsOneNoteIcon,
  MsOutlookIcon,
  MsPowerPointIcon,
  MsSharePointIcon,
  MsWordIcon,
  MsYammerIcon,
  NetflixIcon,
  NeutralIcon,
  NodeJsIcon,
  NotionIcon,
  NpmIcon,
  NylasIcon,
  OKIcon,
  OperaIcon,
  OpsGenieIcon,
  PatreonIcon,
  PayPalIcon,
  PhoneIcon,
  PhpIcon,
  PinterestIcon,
  PixelIcon,
  PostMarkAppIcon,
  PythonIcon,
  QuickBooks1Icon,
  QuoraIcon,
  QzoneIcon,
  ReactIcon,
  RedditIcon,
  ReduxIcon,
  RlangIcon,
  RubyIcon,
  SadIcon,
  SafariIcon,
  SalesForceIcon,
  SkypeIcon,
  SlackIcon,
  SnapChatIcon,
  SoundCloudIcon,
  SourceTreeIcon,
  SpectrumIcon,
  SpotifyIcon,
  StackOverFlowIcon,
  StatusPageIcon,
  SublimeTextIcon,
  SwiftIcon,
  TeamsIcon,
  TelegramIcon,
  ThingsIcon,
  TiktokIcon,
  TinderIcon,
  TorIcon,
  TreeHouseIcon,
  TrelloIcon,
  TumblerIcon,
  TwitterIcon,
  UcIcon,
  ViberIcon,
  VimeoIcon,
  VisaIcon,
  VkIcon,
  VsCodeIcon,
  VueIcon,
  WebFromIcon,
  WebhookIcon,
  WeChatIcon,
  WeeblyIcon,
  WeiboIcon,
  WhatsappIcon,
  WordPressIcon,
  WorkFlowyIcon,
  YandexIcon,
  Yii1Icon,
  YoutubeIcon,
  ZapierIcon,
  ZapierLogoIcon,
  ZendeskIcon,
  ZoomIcon,
} from "convertupleads-theme";
import { IconsWrapper } from "./OutlinedIcons";

const ColoredIcons = () => {
  return (
    <IconsWrapper>
      <IconTitle icon={<SalesForceIcon />} title={"SalesForceIcon"} />
      <IconTitle icon={<FacebookIcon />} title={"FacebookIcon"} />
      <IconTitle icon={<TwitterIcon />} title={"TwitterIcon"} />
      <IconTitle icon={<VkIcon />} title={"VkIcon"} />
      <IconTitle icon={<LinkedInIcon />} title={"LinkedInIcon"} />
      <IconTitle icon={<InstagramIcon />} title={"InstagramIcon"} />
      <IconTitle icon={<PinterestIcon />} title={"PinterestIcon"} />
      <IconTitle icon={<StackOverFlowIcon />} title={"StackOverFlowIcon"} />
      <IconTitle icon={<MozillaIcon />} title={"MozillaIcon"} />
      <IconTitle icon={<SafariIcon />} title={"SafariIcon"} />
      <IconTitle icon={<GoogleChromeIcon />} title={"GoogleChromeIcon"} />
      <IconTitle icon={<SkypeIcon />} title={"SkypeIcon"} />
      <IconTitle icon={<GmailIcon />} title={"GmailIcon"} />
      <IconTitle icon={<ContactShareIcon />} title={"ContactShareIcon"} />
      <IconTitle icon={<FollowUpBossIcon />} title={"FollowupbossIcon"} />
      <IconTitle icon={<ApiIcon />} title={"ApiIcon"} />
      <IconTitle icon={<PhoneIcon />} title={"PhoneIcon"} />
      <IconTitle icon={<WebFromIcon />} title={"WebFromIcon"} />
      <IconTitle icon={<ChatGptIcon />} title={"ChatGptIcon"} />
      <IconTitle icon={<EmailParserIcon />} title={"EmailParserIcon"} />
      <IconTitle icon={<ZapierIcon />} title={"ZapierIcon"} />
      <IconTitle icon={<CarrierLookUpIcon />} title={"CarrierLookUpIcon"} />
      <IconTitle icon={<PixelIcon />} title={"PixelIcon"} />
      <IconTitle icon={<PostMarkAppIcon />} title={"PostmarkappIcon"} />
      <IconTitle icon={<NylasIcon />} title={"NylasIcon"} />
      <IconTitle icon={<AwsIcon />} title={"AwsIcon"} />
      <IconTitle icon={<PayPalIcon />} title={"PayPalIcon"} />
      <IconTitle icon={<MasterCardIcon />} title={"MasterCardIcon"} />
      <IconTitle icon={<VisaIcon />} title={"VisaIcon"} />
      <IconTitle icon={<GoogleIcon />} title={"GoogleIcon"} />
      <IconTitle icon={<MicrosoftIcon />} title={"MicrosoftIcon"} />
      <IconTitle icon={<OperaIcon />} title={"OperaIcon"} />
      <IconTitle icon={<IeIcon />} title={"IeIcon"} />
      <IconTitle icon={<UcIcon />} title={"UcIcon"} />
      <IconTitle icon={<EdgeIcon />} title={"EdgeIcon"} />
      <IconTitle icon={<TorIcon />} title={"TorIcon"} />
      <IconTitle icon={<YandexIcon />} title={"YandexIcon"} />
      <IconTitle icon={<SalesForceIcon />} title={"SalesForceIcon"} />
      <IconTitle icon={<HubSpot1Icon />} title={"HubSpot1Icon"} />
      <IconTitle icon={<GoogleSheetIcon />} title={"GoogleSheetIcon"} />
      <IconTitle icon={<QuickBooks1Icon />} title={"QuickBooks1Icon"} />
      <IconTitle icon={<ConstantContactIcon />} title={"ConstantContactIcon"} />
      <IconTitle icon={<SnapChatIcon />} title={"SnapChatIcon"} />
      <IconTitle icon={<QuoraIcon />} title={"QuoraIcon"} />
      <IconTitle icon={<TinderIcon />} title={"TinderIcon"} />
      <IconTitle icon={<RedditIcon />} title={"RedditIcon"} />
      <IconTitle icon={<WeiboIcon />} title={"WeiboIcon"} />
      <IconTitle icon={<QzoneIcon />} title={"QzoneIcon"} />
      <IconTitle icon={<TumblerIcon />} title={"TumblerIcon"} />
      <IconTitle icon={<FourSquareIcon />} title={"FourSquareIcon"} />
      <IconTitle icon={<TiktokIcon />} title={"TiktokIcon"} />
      <IconTitle icon={<BadooIcon />} title={"BadooIcon"} />
      <IconTitle icon={<OKIcon />} title={"OKIcon"} />
      <IconTitle icon={<AskFmIcon />} title={"AskFmIcon"} />
      <IconTitle icon={<PatreonIcon />} title={"PatreonIcon"} />
      <IconTitle icon={<WebhookIcon />} title={"WebhookIcon"} />
      <IconTitle icon={<TelegramIcon />} title={"TelegramIcon"} />
      <IconTitle icon={<WhatsappIcon />} title={"WhatsappIcon"} />
      <IconTitle icon={<ViberIcon />} title={"ViberIcon"} />
      <IconTitle icon={<SlackIcon />} title={"SlackIcon"} />
      <IconTitle icon={<MessengerIcon />} title={"MessengerIcon"} />
      <IconTitle icon={<LineIcon />} title={"LineIcon"} />
      <IconTitle icon={<WeChatIcon />} title={"WeChatIcon"} />
      <IconTitle icon={<KakaoTalkIcon />} title={"KakaoTalkIcon"} />
      <IconTitle icon={<HangoutsIcon />} title={"HangoutsIcon"} />
      <IconTitle icon={<MessagesIcon />} title={"MessagesIcon"} />
      <IconTitle icon={<SpectrumIcon />} title={"SpectrumIcon"} />
      <IconTitle icon={<ZoomIcon />} title={"ZoomIcon"} />
      <IconTitle icon={<DiscordIcon />} title={"DiscordIcon"} />
      <IconTitle icon={<FaceTimeIcon />} title={"FaceTimeIcon"} />
      <IconTitle icon={<GitIcon />} title={"GitIcon"} />
      <IconTitle icon={<Css3Icon />} title={"Css3Icon"} />
      <IconTitle icon={<Html5Icon />} title={"Html5Icon"} />
      <IconTitle icon={<JavascriptIcon />} title={"JavascriptIcon"} />
      <IconTitle icon={<NodeJsIcon />} title={"NodeJsIcon"} />
      <IconTitle icon={<BitBucketIcon />} title={"BitBucketIcon"} />
      <IconTitle icon={<CodepenIcon />} title={"CodepenIcon"} />
      <IconTitle icon={<JqueryIcon />} title={"JqueryIcon"} />
      <IconTitle icon={<JbRiderIcon />} title={"JbRiderIcon"} />
      <IconTitle icon={<JbReshaperIcon />} title={"JbReshaperIcon"} />
      <IconTitle icon={<JbReshaperCppIcon />} title={"JbReshaperCppIcon"} />
      <IconTitle icon={<JbAppCodeIcon />} title={"JbAppCodeIcon"} />
      <IconTitle icon={<JbCilonIcon />} title={"JbCilonIcon"} />
      <IconTitle icon={<JbDataGripIcon />} title={"JbDataGripIcon"} />
      <IconTitle icon={<JbGolandIcon />} title={"JbGolandIcon"} />
      <IconTitle icon={<JbPhpStormIcon />} title={"JbPhpStormIcon"} />
      <IconTitle icon={<JbPyCharmIcon />} title={"JbPyCharmIcon"} />
      <IconTitle icon={<JbRubyMineIcon />} title={"JbRubyMineIcon"} />
      <IconTitle icon={<JbWebStormIcon />} title={"JbWebStormIcon"} />
      <IconTitle icon={<JbDotCoverIcon />} title={"JbDotCoverIcon"} />
      <IconTitle icon={<JbDotMemoryIcon />} title={"JbDotMemoryIcon"} />
      <IconTitle icon={<JbDotPeekIcon />} title={"JbDotPeekIcon"} />
      <IconTitle icon={<JbDotTraceIcon />} title={"JbDotTraceIcon"} />
      <IconTitle icon={<JbTeamCityIcon />} title={"JbTeamCityIcon"} />
      <IconTitle icon={<JbUpSourceIcon />} title={"JbUpSourceIcon"} />
      <IconTitle icon={<JbYouTrackIcon />} title={"JbYouTrackIcon"} />
      <IconTitle icon={<JbHubIcon />} title={"JbHubIcon"} />
      <IconTitle icon={<JbPyCharmEduIcon />} title={"JbPyCharmEduIcon"} />
      <IconTitle icon={<JbKotlinIcon />} title={"JbKotlinIcon"} />
      <IconTitle icon={<JbIntelliJIcon />} title={"JbIntelliJIcon"} />
      <IconTitle icon={<JbToolBoxAppIcon />} title={"JbToolBoxAppIcon"} />
      <IconTitle icon={<SublimeTextIcon />} title={"SublimeTextIcon"} />
      <IconTitle icon={<VsCodeIcon />} title={"VsCodeIcon"} />
      <IconTitle icon={<AtomIcon />} title={"AtomIcon"} />
      <IconTitle icon={<PythonIcon />} title={"PythonIcon"} />
      <IconTitle icon={<JavaIcon />} title={"JavaIcon"} />
      <IconTitle icon={<CplusPlusIcon />} title={"CplusPlusIcon"} />
      <IconTitle icon={<GoIcon />} title={"GoIcon"} />
      <IconTitle icon={<RlangIcon />} title={"RlangIcon"} />
      <IconTitle icon={<SwiftIcon />} title={"SwiftIcon"} />
      <IconTitle icon={<PhpIcon />} title={"PhpIcon"} />
      <IconTitle icon={<ChashIcon />} title={"ChashIcon"} />
      <IconTitle icon={<RubyIcon />} title={"RubyIcon"} />
      <IconTitle icon={<DockerIcon />} title={"DockerIcon"} />
      <IconTitle icon={<AngularIcon />} title={"AngularIcon"} />
      <IconTitle icon={<VueIcon />} title={"VueIcon"} />
      <IconTitle icon={<DrupalIcon />} title={"DrupalIcon"} />
      <IconTitle icon={<JoomlaIcon />} title={"JoomlaIcon"} />
      <IconTitle icon={<WordPressIcon />} title={"WordPressIcon"} />
      <IconTitle icon={<ReactIcon />} title={"ReactIcon"} />
      <IconTitle icon={<NpmIcon />} title={"NpmIcon"} />
      <IconTitle icon={<ReduxIcon />} title={"ReduxIcon"} />
      <IconTitle icon={<WeeblyIcon />} title={"WeeblyIcon"} />
      <IconTitle icon={<Yii1Icon />} title={"Yii1Icon"} />
      <IconTitle icon={<AdobeDwIcon />} title={"AdobeDwIcon"} />
      <IconTitle icon={<GDriveIcon />} title={"GDriveIcon"} />
      <IconTitle icon={<GcalendarIcon />} title={"GcalendarIcon"} />
      <IconTitle icon={<GdocIcon />} title={"GdocIcon"} />
      <IconTitle icon={<GmeetIcon />} title={"GmeetIcon"} />
      <IconTitle icon={<GmapIcon />} title={"GmapIcon"} />
      <IconTitle icon={<AtlassianIcon />} title={"AtlassianIcon"} />
      <IconTitle icon={<ConfluenceIcon />} title={"ConfluenceIcon"} />
      <IconTitle icon={<JiraIcon />} title={"JiraIcon"} />
      <IconTitle icon={<TrelloIcon />} title={"TrelloIcon"} />
      <IconTitle icon={<JiraServiceDeskIcon />} title={"JiraServiceDeskIcon"} />
      <IconTitle icon={<JiraOpsIcon />} title={"JiraOpsIcon"} />
      <IconTitle icon={<JiraCoreIcon />} title={"JiraCoreIcon"} />
      <IconTitle icon={<StatusPageIcon />} title={"StatusPageIcon"} />
      <IconTitle icon={<OpsGenieIcon />} title={"OpsGenieIcon"} />
      <IconTitle icon={<BambooIcon />} title={"BambooIcon"} />
      <IconTitle icon={<SourceTreeIcon />} title={"SourceTreeIcon"} />
      <IconTitle icon={<FlowMapIcon />} title={"FlowMapIcon"} />
      <IconTitle icon={<MailChimpIcon />} title={"MailChimpIcon"} />
      <IconTitle icon={<DropBoxIcon />} title={"DropBoxIcon"} />
      <IconTitle icon={<ExcelIcon />} title={"ExcelIcon"} />
      <IconTitle icon={<MsWordIcon />} title={"MsWordIcon"} />
      <IconTitle icon={<MsOneNoteIcon />} title={"MsOneNoteIcon"} />
      <IconTitle icon={<MsOutlookIcon />} title={"MsOutlookIcon"} />
      <IconTitle icon={<MsPowerPointIcon />} title={"MsPowerPointIcon"} />
      <IconTitle icon={<MsSharePointIcon />} title={"MsSharePointIcon"} />
      <IconTitle icon={<TeamsIcon />} title={"TeamsIcon"} />
      <IconTitle icon={<MsYammerIcon />} title={"MsYammerIcon"} />
      <IconTitle icon={<EverNoteIcon />} title={"EverNoteIcon"} />
      <IconTitle icon={<ZendeskIcon />} title={"ZendeskIcon"} />
      <IconTitle icon={<KayakoIcon />} title={"KayakoIcon"} />
      <IconTitle icon={<IntercomIcon />} title={"IntercomIcon"} />
      <IconTitle icon={<TreeHouseIcon />} title={"TreeHouseIcon"} />
      <IconTitle icon={<FinderIcon />} title={"FinderIcon"} />
      <IconTitle icon={<ZapierLogoIcon />} title={"ZapierLogoIcon"} />
      <IconTitle icon={<NotionIcon />} title={"NotionIcon"} />
      <IconTitle icon={<ThingsIcon />} title={"ThingsIcon"} />
      <IconTitle icon={<WorkFlowyIcon />} title={"WorkFlowyIcon"} />
      <IconTitle icon={<MsOneDriveIcon />} title={"MsOneDriveIcon"} />
      <IconTitle icon={<AmazonIcon />} title={"AmazonIcon"} />
      <IconTitle icon={<AsanaIcon />} title={"AsanaIcon"} />
      <IconTitle icon={<BaseCampIcon />} title={"BaseCampIcon"} />
      <IconTitle icon={<EvilIcon />} title={"EvilIcon"} />
      <IconTitle icon={<DissatisfiedIcon />} title={"DissatisfiedIcon"} />
      <IconTitle icon={<CryIcon />} title={"CryIcon"} />
      <IconTitle icon={<SadIcon />} title={"SadIcon"} />
      <IconTitle icon={<NeutralIcon />} title={"NeutralIcon"} />
      <IconTitle icon={<FriendlyIcon />} title={"FriendlyIcon"} />
      <IconTitle icon={<HospitableIcon />} title={"HospitableIcon"} />
      <IconTitle icon={<HappyIcon />} title={"HappyIcon"} />
      <IconTitle icon={<LoveIcon />} title={"LoveIcon"} />
      <IconTitle icon={<CookieIcon />} title={"CookieIcon"} />
      <IconTitle icon={<YoutubeIcon />} title={"YoutubeIcon"} />
      <IconTitle icon={<VimeoIcon />} title={"VimeoIcon"} />
      <IconTitle icon={<FlickrIcon />} title={"FlickrIcon"} />
      <IconTitle icon={<NetflixIcon />} title={"NetflixIcon"} />
      <IconTitle icon={<SoundCloudIcon />} title={"SoundCloudIcon"} />
      <IconTitle icon={<SpotifyIcon />} title={"SpotifyIcon"} />
      <IconTitle icon={<FigmaIcon />} title={"FigmaIcon"} />
      <IconTitle icon={<AndroidIcon />} title={"AndroidIcon"} />
      <IconTitle icon={<IosIcon />} title={"IosIcon"} />
      <IconTitle icon={<GiftWrappedIcon />} title={"GiftWrappedIcon"} />
      <IconTitle icon={<DeliveryTruckIcon />} title={"DeliveryTruckIcon"} />
      <IconTitle icon={<DirectHitIcon />} title={"DirectHitIcon"} />
      <IconTitle icon={<FileFolderIcon />} title={"FileFolderIcon"} />
    </IconsWrapper>
  );
};

export default ColoredIcons;
